import React from 'react'
import PropTypes from 'prop-types'

import { AccordionDetails, IconButton, Typography, Divider } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { memo } from 'utils/react'
import { AccordionSummary } from 'components/common/HHAccordion'
import { COMMON } from 'theme/colors'
import { StyledAccordion } from './StyledAccordion'

const YearAccordion = ({ isExpanded = false, year, onChange, children }) => {
  return (
    <StyledAccordion
      expanded={isExpanded}
      elevation={0}
      disablePointer
      onChange={onChange}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary
        sx={{ border: 0, background: COMMON.white, '& .MuiAccordionSummary-content': { ml: 1 } }}
        expandIcon={
          <IconButton>
            <ChevronRightIcon />
          </IconButton>
        }
      >
        <Typography variant="h5" fontWeight={500}>
          {year}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Divider />
        {children}
      </AccordionDetails>
    </StyledAccordion>
  )
}

YearAccordion.propTypes = {
  isExpanded: PropTypes.bool,
  year: PropTypes.number,
  onChange: PropTypes.func,
  children: PropTypes.node,
}

export default memo(YearAccordion)
